import { Component, OnInit, ViewChild, HostListener, AfterViewInit }      from '@angular/core';
import {FormControl, FormGroupDirective, NgForm, Validators}              from '@angular/forms';
import {ErrorStateMatcher}                                                from '@angular/material/core';
import { Router, ActivatedRoute }                                         from '@angular/router';
import { first, map }                                                     from 'rxjs/operators';

import { AlertService, ExamService }                     		          from '../_services';
import { Globals  }                                                       from '../_helpers';
import swal,{ SweetAlertOptions }                                         from 'sweetalert2';
import { SwalComponent }                                                  from '@toverux/ngx-sweetalert2';
import { NgxSpinnerService }                                              from 'ngx-spinner';
import * as RecordRTC 											          from 'recordrtc';
import { DomSanitizer } 										          from '@angular/platform-browser';

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
  	selector: 'assessor-test-viva',
  	templateUrl: './viva-pc.component.html',
  	styleUrls: ['./viva-pc.component.css']
})

export class VivaPcComponent implements OnInit{

    marksFormControl = new FormControl('', [
        
    ]);

    @ViewChild('video') video;
    @ViewChild('audio') audio;

  	@ViewChild('rerecordVideoSwal') private rerecordVideoSwal: SwalComponent;
    @ViewChild('rerecordAudioSwal') private rerecordAudioSwal: SwalComponent;
    @ViewChild('stoprecordingSwal') private stoprecordingSwal: SwalComponent;
/*    @ViewChild('timeoverSwal') private timeoverSwal: SwalComponent;
    @ViewChild('exitexamSwal') private exitexamSwal: SwalComponent;*/
    @ViewChild('oneAnswerSwal') private oneAnswerSwal: SwalComponent;
    @ViewChild('checkedSwal') private checkedSwal: SwalComponent;
    @ViewChild('urlSwal') private urlSwal: SwalComponent;
    @ViewChild('mandatorySwal') private mandatorySwal: SwalComponent;

    public alertOption:SweetAlertOptions = {};

    matcher = new MyErrorStateMatcher();

    @HostListener('window:keyup', ['$event']) 
    onKeyupHandler(event: KeyboardEvent) {
        //console.log(event.keyCode);
        if(event.keyCode == 123 || event.keyCode == 122)
            //this.autoSubmitAnswers();
        // console.log(event.keyCode);
        event.stopPropagation();
    }

    nos: string = '';
    studentName: string = '';
    studentCode: string = '';
    answerdObj = {};
    notSubmitObj = [];
	questArr = [];
	loading = false;
    indexClasses: string;
	timershow: string;
    returnUrl: string;
    maxMarks : number;
    duration : number = 0;
    photo:string;
    type : string;
    totalQuestion: number;
    question : string;
    questionInst: string;
    index : number = 1;
    answer_id: number;
    answer_type:string;
    deficulty_lebel: number = 0;
    userData = {};
    settings = {};
    distance:any;
    totalAnswered:number = 0;
    totalSubmited:number = 0;
    totalVisited:number = 0;
    totalNotAnswered:number = 0;
    interval;
    settime;
    isPause = false;
    visitedQuesObj = {};
    isSubmit = false;
    isPauseBtn = false;
    isRerecord = false;

    isMedia = false;
    qaudioUrl: string = ''; 
    qvideoUrl: string = '';
    qimageUrl: string = ''; 
    isDone = false; 
    currentIndex = 0;
    student_id: number = 0;
    question_id: number = 0;
    chapter_id: number = 0;
    checked: number = 0;
    marks: string = ''; 

    prevques = [];
    options = [];
    sub_questions = [];
    isResetBtn = false;
    isSpeech = true;
    assessorName;
    mandatory: number = 0;

    /* Chart Variable */
    //public pieChartLabels:string[] = ['Submitted', 'Visitted', 'Not Visitted'];
    public pieChartLabels:string[] = ['Attempted', 'Not Attempted'];
    public pieChartData:number[] = [];
    public pieChartType:string = 'pie';
    public pieChartLegend = false;
    public chartColors: any[] = [{ 
        backgroundColor:["#44e51e", "#c4c4c4"] 
    }];

    public recordTimer: string;
    public recording = false;
    public isVideo = true;
    public isAudio = true;
    public videoRecording = false;
    public audioRecording = false;
    public videoUrl;
    public audioUrl;
    speechLang: string = 'en-GB';
    instructions = [];

    private stream: MediaStream;
    private recordRTC: any;

    binaryData = [];
    activeExam = {};
    examid:number = 0;

	constructor(
        private route: ActivatedRoute,
        private router: Router,
        private examService: ExamService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private domSanitizer: DomSanitizer
    ) { }

    ngOnInit() {

        var step = this.route.snapshot.paramMap.get("step");
        if(step != '')
        {
            //this.globals.studentId = step;
            this.student_id = parseInt(step);
        }
        else{
            this.router.navigateByUrl('/exam-list');
        }

        //this.requestFullscreen(document.documentElement);

    	this.userData = JSON.parse(localStorage.getItem('currentUser'));
        this.assessorName = this.userData['name_assessor'];         
        this.isSubmit = true;
        this.isPauseBtn = true;
        this.activeExam = JSON.parse(localStorage.getItem('activeExam_PS'));
        this.examid = this.activeExam['exam_id'];
        /*if(this.settings['submit'] == 0)
            this.isSubmit = true;
        if(this.settings['student_pause'] == 0){
            this.isPauseBtn = true;
        }*/

    	/* call function for first question and exam info */
 		this.getVivaExams();

        // get return url from route parameters or default to '/'
        this.returnUrl = '/';
    }

    /* Get Exam data when exam UI is load */
    private getVivaExams(){
    	this.loading = true;
        this.spinner.show();
    	this.questArr= [];
    	this.options = [];
        this.answerdObj = {};
        this.isMedia = false;
        this.qaudioUrl = ''; 
        this.qvideoUrl = '';
        this.qimageUrl = '';
        this.examService.getVivaPCFirstQuestion(this.globals.root_url, this.userData['usercode'], this.student_id, this.userData['exam_id'], this.userData['id'])
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    let exam = data.question;
                    //this.duration = exam.duration;
                    this.photo =data.photo;
                    this.type = 'PC-Viva/Practical';//exam.type;
                    this.totalQuestion = data.total_question;
                    //console.log(this.totalQuestion);
                    let questionData = exam[0];
                    //console.log(questionData);
                    //this.answer_id = 0;
                    this.question = questionData.question;
                    this.prevques = questionData.res;
                    this.questionInst = questionData.question_instruction;
                    this.maxMarks = questionData.max_marks;
                    this.question_id = questionData.id_qb_question;
                    this.chapter_id = questionData.id_chapter;
                    this.nos = questionData.nos;
                    this.speechLang = questionData.que_language;
                    this.mandatory = data.mandatory;
                    if(questionData.upload_media != ''){
                        this.isMedia = true;
                        if(questionData.media_type == 2){
                            this.qimageUrl = questionData.upload_media;
                        }
                        else if(questionData.media_type == 3){
                           this.qaudioUrl = questionData.upload_media; 
                        }
                        else if(questionData.media_type == 4){ 
                            this.qvideoUrl = questionData.upload_media;
                        }
                    }

                    /* Set counter */
                    //this.counter(exam.duration);

                    /* set button background color */
                    this.btnStyle(1, 'current');
                    this.visitedQuesObj[1] = 'visited';

//console.log(questionData.sub_questions);
                    /* Create Option obj */
                    this.createOptionsObj(questionData.sub_questions);

                    /* Create array for question index */
                    this.createArrayQuesNoObj(this.totalQuestion, this.prevques);

                    let inst = (questionData.question_instruction).split('\n');
                    for (var i = 0; i < inst.length; i++) {
                        let html = inst[i];
                        if (html != '')
                            this.instructions[i] = { text: html };
                    }

                    this.spinner.hide();
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
                else{
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
                
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                //this.router.navigateByUrl('/login');
                this.spinner.hide();
            }
        );
    }

    /* Get Exam data by index number */
    private getQuestionByIndex(){ console.log('this.index 2', this.index)
    	this.loading = true;
        this.spinner.show();
        this.isMedia = false;
        this.qaudioUrl = ''; 
        this.qvideoUrl = '';
        this.qimageUrl = '';
        this.options = [];
        this.examService.getVivaPCFByIndex(this.globals.root_url, this.userData['usercode'], this.student_id, this.userData['exam_id'], this.index)
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    let exam = data.question;
                    //this.duration = exam.duration;
                    this.photo = data.photo;
                    this.type = 'PC-Viva/Practical';
                    this.totalQuestion = data.total_question;
                    //console.log(this.totalQuestion);
                    let questionData = exam[0];
                    //console.log(questionData);
                    //this.answer_id = 0;
                    this.question = questionData.question;
                    this.prevques = questionData.res;
                    this.questionInst = questionData.question_instruction;
                    this.maxMarks = questionData.max_marks;
                    this.question_id = questionData.id_qb_question;
                    this.chapter_id = questionData.id_chapter;
                    this.nos = questionData.nos;
                    if(questionData.upload_media != ''){
                        this.isMedia = true
                        if(questionData.media_type == 2){
                            this.qimageUrl = questionData.upload_media;
                        }
                        else if(questionData.media_type == 3){
                           this.qaudioUrl = questionData.upload_media; 
                        }
                        else if(questionData.media_type == 4){ 
                            this.qvideoUrl = questionData.upload_media;
                        }
                    }
/*console.log(this.answerdObj);
                    if (this.index in this.answerdObj) {
                        this.answer_id = this.answerdObj[this.index];
                        this.optBtnStyle(this.answer_id, this.index);
                        this.btnStyle(this.index, 'answeredCurr');
                        this.visitedQuesObj[this.index] = 'answered';
                    }
                    else {
                        this.visitedQuesObj[this.index] = 'visited';
                        this.btnStyle(this.index, 'current');
                    }*/

                    /* set button background color */
                    //this.btnStyle(this.index, 'current');
                    //this.visitedQuesObj[this.index] = 'visited';

//console.log(questionData.sub_questions);
                    /* Create Option obj */
                    this.createOptionsObj(questionData.sub_questions);

                    /* Create array for question index */
                    //this.createArrayQuesNoObj(this.totalQuestion, this.prevques);

                    let inst = (questionData.question_instruction).split('\n');
                    for (var i = 0; i < inst.length; i++) {
                        let html = inst[i];
                        if (html != '')
                            this.instructions[i] = { text: html };
                    }

                    this.spinner.hide();
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
                else{
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
                
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                //this.router.navigateByUrl('/login');
                this.spinner.hide();
            }
        );
    }
    /* Create question option array */
    private createOptionsObj(options) {
        for (var i = 0; i < options.length; ++i) {
            this.options[i] = { optiontext: options[i].sub_question, id: options[i].sub_id_qb_question, marks:  options[i].sub_question_mark};
            var lockOption = options[i].checked;
            var marks = options[i].sub_question_mark;
            var select_option = options[i].checked;
            if (select_option == 1) {
                /* set button background color */
                this.btnStyle(this.index, 'submited');
                /* Set question visited */
                this.visitedQuesObj[this.index] = 'submited';
                this.answer_id = options[i].sub_id_qb_question;
                this.answerdObj[this.index] = this.answer_id;
                this.optBtnStyle(this.answer_id, select_option);
                this.isSubmit = true;
                this.checked = 1;
                this.isResetBtn = true;
                this.notSubmitObj.push({ sub_id_qb_question: options[i].sub_id_qb_question, marks: options[i].sub_question_mark, sub_id_chapter: options[i].sub_id_chapter, is_checked: this.checked});
            }
            if (select_option == 0) {
                this.answer_id =  options[i].sub_id_qb_question;
                this.answerdObj[this.index] = this.answer_id;
                this.btnStyle(this.index, 'visited');
                this.visitedQuesObj[this.index] = 'visited';
                this.optBtnStyle(this.answer_id, select_option);
                //this.notSubmitObj.push({ sub_id_qb_question: options[i].sub_id_qb_question, marks: options[i].sub_question_mark, sub_id_chapter: options[i].sub_id_chapter, is_checked: this.checked});                
            }
        }
		//console.log(options);
        this.spinner.hide();
    }
    /* Change option btn color */
    private optBtnStyle(btnIndex, indexId) {
        setTimeout(function () {
            var currentOptBtn = document.getElementById('op-' + btnIndex) as HTMLInputElement;
            if (typeof currentOptBtn != 'undefined') {
            	if(indexId == 1)
            	{
					currentOptBtn.checked = true;
            	}
            	else{
					if(currentOptBtn.checked == true){currentOptBtn.checked = false;}        		
            	}
            }
        }, 200);
    }
    /* Exam option select event */
    public optionSelected(event, indx) {
            var currentOptBtn = document.getElementById('op-' + indx) as HTMLInputElement;
            if(currentOptBtn.checked == true)
            {
				this.checked = 1;
				this.marks = currentOptBtn.value;
            }
            else{
            	this.checked = 0;
            	this.marks = currentOptBtn.value;            
            }

            /*set answer with question */
            this.answerdObj[this.index] = this.answer_id;
            for (var i = 0; i < this.notSubmitObj.length; i++) {
                if (this.notSubmitObj[i].sub_id_qb_question == indx)
                    this.notSubmitObj.splice(i, 1);
            }
            this.notSubmitObj.push({ sub_id_qb_question: indx, marks: this.marks, sub_id_chapter: this.chapter_id, is_checked: this.checked });
            this.visitedQuesObj[this.index] = 'answered';
            //console.log(this.notSubmitObj);
    }    
    /* Save current and get next */
    private saveAndNext(action){
        speechSynthesis.cancel();
    	if(action == 'next'){ console.log('this.index 3-1', this.index)
	    	let curind =  this.getNextIndex('next', this.index + 1);
	        this.index = curind;
	    }
	    else if(action == 'prev'){
	    	let curind =  this.getNextIndex('prev', this.index - 1);
	    	this.index = curind;
	    }
        console.log('this.index 3-2', this.index)
    }

    /* On index click get this question */
    public getQuestionIndex(event, item){
		//if(this.visitedQuesObj[item] != 'submited'){
/*         if(this.checked == 0)
        {
          this.checkedSwal.show(); 
          return;   
        }  */        
    	this.index = item;
    	//this.saveAndNext('current');
    	if(this.visitedQuesObj[this.index] == 'submited')
        	this.visitedQuesObj[this.index] = 'submited';
        else
        	this.visitedQuesObj[this.index] = 'visited';
        this.getQuestionByIndex();
       // }
    }

    /* Check Submitted question and jump to next */
    private getNextIndex(type, index){ //console.log('index ', index);
        let questDb = this.visitedQuesObj; 
        if(Object.keys(questDb).length < 1){
            return index;
        }
        else if(type == 'next') {
            for (var i = index; i < this.totalQuestion; ++i) {
                //if(questDb[i] != 'submited')
                   return i;
            }
            return index;
        }
        else if(type == 'prev'){ 
            for (var i = index; i > 0; --i){ //console.log('questDb[i] ', questDb[i]);
                //if(questDb[i] != 'submited')
                   return i;
            }
            //return index + 1;
        }
    }
    /* On click previous button get question */
    public prevQuestion(){
        speechSynthesis.cancel(); 
        //console.log('this.index ',this.index);
		if(this.index > 1){
            let curind = this.getNextIndex('prev', this.index - 1);
            this.index = curind;
            //this.visitedQuesObj[this.index] = 'visited';
            //console.log(this.index);
            //this.index = this.index - 1;
            this.getQuestionByIndex();
                    //console.log('this.index after ', curind);
            //console.log(this.index);

/*            this.visitedQuesObj[this.index] = 'visited';
            let curind = this.getNextIndex('prev', this.index - 1);
            this.index = curind;
            console.log(this.index);
            this.getQuestionByIndex(); */          
	    }
    }

    /* On click next button get question */
    public nextQuestion(){  
        speechSynthesis.cancel();
/*	    if(this.mandatory == 1)
	    {
	      if(this.checked == 0)
          {
            this.checkedSwal.show(); 
            return;               
          }     
	    }*/
        if(this.checked == 0)
        {
            if (this.index < this.totalQuestion) {
                this.saveAndNext('next');
                this.visitedQuesObj[this.index] = 'visited';
                this.getQuestionByIndex();
            }
            else if (this.index == this.totalQuestion) 
            {
              this.openSubmitArea();   
            }
        }
        else{ console.log('this.index ', this.index);
            if (this.index < this.totalQuestion) {
                //this.visitedQuesObj[this.index] = 'visited';             
                this.submitSingleQuestion(this.index, this.question_id, this.notSubmitObj);
                this.saveAndNext('next');
                this.getQuestionByIndex();
            }
            else if (this.index == this.totalQuestion) {
                this.submitSingleQuestion(this.index, this.question_id, this.notSubmitObj);
               //this.visitedQuesObj[this.index] = 'visited';
                //this.openSubmitArea();
                            //console.log(this.visitedQuesObj);
            }
        }
        //this.answer_id = 0;            
    }
  /* submit single question*/ 
  public submitSingleQuestion(index, question_id, sub_questions) {
	var answers = [];
	var students = [{
		answers: this.notSubmitObj
	}];

	var studentsStr = JSON.stringify(sub_questions); 	
    this.loading = true;
    this.spinner.show();
    this.examService.setVivaPCQuestionByIndex(this.globals.root_url, this.userData['usercode'], this.userData['exam_id'], this.student_id, index, studentsStr, this.checked, question_id)
      .pipe(first())
      .subscribe(
        data => {
            if (data.code == 1000) {
              if (index == this.totalQuestion) {
                this.spinner.hide();            
                this.checked = 0;
                this.notSubmitObj = [];
                this.loading = false;
                this.btnStyle(index, 'submited');
                this.visitedQuesObj[index] = 'submited';   
                this.openSubmitArea();         
              }
              else{
                this.checked = 0;
                this.notSubmitObj = [];
                this.spinner.hide();
                this.loading = false;
                this.btnStyle(index, 'submited');
                this.visitedQuesObj[index] = 'submited';  
              }
          }
          else {
            this.loading = false;
            //this.router.navigateByUrl('/login');
          }
         // this.spinner.hide();
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
          this.router.navigateByUrl('/login');
          this.spinner.hide();
        }
      );
  }

    /* Pie chart */
    public openSubmitArea() {
/*        if(this.mandatory == 1)
        {
          if(this.checked == 0)
          {
            this.checkedSwal.show(); 
            return;               
          }     
        } */
            let visitedq = 0;
            let submitedq = 0;
            let answerdq = 0;
            let notAttemptq = 0;
            if (Object.keys(this.visitedQuesObj).length > 0) {
                for (let ansobj in this.visitedQuesObj) {
                    if (this.visitedQuesObj[ansobj] == 'submited')
                        submitedq++;
                    else if (this.visitedQuesObj[ansobj] == 'visited')
                        visitedq++;
                    else if (this.visitedQuesObj[ansobj] == 'answered')
                        answerdq++;
                }

                notAttemptq = this.totalQuestion - (submitedq + visitedq + answerdq);
            }
            else {
                notAttemptq = this.totalQuestion;
            }

            //this.pieChartData = [submitedq, visitedq, notAttemptq];
            this.totalAnswered = answerdq;
            this.totalSubmited = submitedq;
            this.totalVisited = visitedq;
            this.totalNotAnswered = notAttemptq + visitedq;
            this.pieChartData = [this.totalSubmited, this.totalNotAnswered];
            this.isDone = true;
            document.getElementById('question-area').style.display = 'none';
            document.getElementById('submited-area').style.display = 'block';
    }
    /* Change button color according to action */
    private btnStyle(btnIndex, status){
        setTimeout( function(){
            var currentBtn = document.getElementById('btn-'+btnIndex);
            if(typeof currentBtn != 'undefined'){
                if(status == 'answered'){
                    currentBtn.classList.add('btn-answered');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-notvisited');
                    currentBtn.classList.remove('visited-btn');
                }
                else if(status == 'submited'){
                    currentBtn.classList.add('btn-submited');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-answered');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-notvisited');
                    currentBtn.classList.remove('visited-btn');
                }
                else if(status == 'visited'){
                    currentBtn.classList.add('btn-visited');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-answered');
                    currentBtn.classList.remove('btn-notvisited');
                }
                else if(status == 'current'){
                    var preBtn = document.getElementsByClassName('visited-btn');
                    if(typeof preBtn != 'undefined' && preBtn.length > 0){
                        for (var i = 0; i < preBtn.length; ++i) {
                            preBtn[i].classList.add('btn-visited');
                            preBtn[i].classList.remove('btn-current');
                            preBtn[i].classList.remove('btn-answered');
                            preBtn[i].classList.remove('btn-notvisited');
                            preBtn[i].classList.remove('visited-btn');
                        }
                    }
                    
                    currentBtn.classList.add('visited-btn');
                    currentBtn.classList.add('btn-current');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-answered');
                    currentBtn.classList.remove('btn-notvisited'); 
                }
                else if(status == 'not-answered'){
                    currentBtn.classList.add('btn-notvisited');
                    currentBtn.classList.remove('visited-btn');
                    currentBtn.classList.remove('btn-current');
                    currentBtn.classList.remove('btn-visited');
                    currentBtn.classList.remove('btn-answered');
                }
            }
        }, 200);
    }

    /* Create array of object for number of question and lebel */
    private createArrayQuesNoObj(totalQuest, preques) { //console.log(preques);
/*        for (var i = 0; i < totalQuest; ++i) {
            this.questArr[i] = { index: i + 1 };
            var setColor = false;
            for (var j = 0; j < preques.length; j++) {
                if (preques[j].index === (i + 1)) {
                    var answer = preques[j].checked ? 1 : 0;
                    if (answer == 1 && setColor == false) {
                        this.btnStyle(preques[j].index, 'answered');
                        this.visitedQuesObj[preques[j].index] = 'answered';
                        setColor = true;
                    }
                    if (answer == 1 && setColor == true) {
                        this.btnStyle(preques[j].index, 'answered');
                        this.visitedQuesObj[preques[j].index] = 'answered';
                        setColor = true;
                    }
                    if (answer == 1 && setColor == false) {
                        this.btnStyle(preques[j].index, 'submited');
                        this.visitedQuesObj[preques[j].index] = 'submited';
                        setColor = true;
                        //this.optBtnStyle(preques[j].answer, preques[j].index); 
                    }
                    else if (answer == 1 && setColor == true) {
                        this.btnStyle(preques[j].index, 'submited');
                        this.visitedQuesObj[preques[j].index] = 'submited';
                        setColor = true;
                    }
                    if (answer == 0 && setColor == false) {
                        this.btnStyle(preques[j].index, 'visited');
                        this.visitedQuesObj[preques[j].index] = 'visited';
                        setColor = true;
                    }
                }
            }
        }*/
        for (var i = 0; i < totalQuest; ++i) {
            this.questArr[i] = { index: i + 1 };

            for (var j = 0; j < preques.length; j++) {
                var setColor = false;
                if (preques[j].index === (i + 1)) {
                    var answer = preques[j].checked ? 1 : 0;
                    if (answer == 1 && setColor == false) {
                        this.btnStyle(preques[j].index, 'submited');
                        this.visitedQuesObj[preques[j].index] = 'submited';
                        setColor = true;
                    }
                    if (answer == 0 && setColor == false) {
                        this.btnStyle(preques[j].index, 'visited');
                        this.visitedQuesObj[preques[j].index] = 'visited';
                        setColor = true;
                    }
                }
            }
        }        
    }

    public backFromFinalSubmit() {
        //console.log(this.visitedQuesObj);
        //console.log(this.index);
        //console.log(this.totalQuestion);
        let indexDb = this.visitedQuesObj;

        /*        for (var i = this.index; i <= this.totalQuestion; i--) {
                    if(indexDb[i] != 'undefined' && indexDb[i] != 'submited')
                       this.currentIndex = i;
                }*/
        if ((this.index == this.totalQuestion) && (indexDb[this.index] != 'submited')) {
            // nothing
        }
        else {
            for (var i = this.index; i > 0; --i) {
                //console.log('loop index '+indexDb[i]);
                if (indexDb[i] == 'visited') {
                    this.index = i;
                    break;
                }

            }
        }
        this.getQuestionByIndex();
        //console.log(this.index);       
        document.getElementById('question-area').style.display = 'block';
        document.getElementById('submited-area').style.display = 'none';
        document.getElementById('exit-test').style.display = 'block';
    }
    public submitExam() {
        if (this.mandatory == 1 && this.totalNotAnswered == 0 && this.totalVisited == 0) {
        //if (this.totalNotAnswered == 0 && this.totalVisited == 0) {
            this.setVivaSubmitted();
        }
        else{
        	this.mandatorySwal.show();
        }

/*        else if (this.settings['mandatory_exam'] == 0) {
            this.setVivaSubmitted();
        } else {
            this.oneAnswerSwal.show();
        }*/
    }
    public finalSubmitExam()
    {
    	 this.setVivaSubmitted();
    }

     /* Final VivaPC Submitted */
    public setVivaSubmitted() { 
        this.userData['usercode'], this.userData['exam_id'], 
        this.loading = true;
        this.spinner.show();
        //this.examService.setVivaSubmit(this.globals.root_url, this.userData['usercode'], this.student_id, this.userData['exam_id'], 2) // ols api calling
        this.examService.setVivaPCSubmit(this.globals.root_url, this.userData['usercode'], this.student_id, this.userData['exam_id'], this.userData['id'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        this.loading = false;
                        this.spinner.hide();                        
                        document.getElementById('thanks-area').style.display = 'block';
                        document.getElementById('submited-area').style.display = 'none';
                        document.getElementById('exit-test').style.display = 'none';
                    }
                    else {
                        this.loading = false;
                        this.spinner.hide();
                        //this.router.navigateByUrl('/login');

                    }
                    this.spinner.hide();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
            );
    }   
    public gotoHome() {
        this.router.navigateByUrl('/student-list/3');
    }   
    myTimeout;  
    /* Text to speech */
    public textToSpeech(){
        var navUserAgent = navigator.userAgent;
        var msg = new SpeechSynthesisUtterance();
        var voices = window.speechSynthesis.getVoices();
        speechSynthesis.cancel();
        var myTimeout = setTimeout(function () {
            speechSynthesis.pause();
            speechSynthesis.resume();
        }, 15700);       
        if(navUserAgent.indexOf("Opera") > -1) 
        {
             //msg.voice = voices[7];
        }else if(navUserAgent.indexOf("Chrome") > -1)
        {
           msg.voice = voices[7];
        }else if(navUserAgent.indexOf("MSIE") > -1 || navUserAgent.indexOf("rv:") > -1)
        {
             //msg.voice = voices[7];
        }else if(navUserAgent.indexOf("Firefox") > -1)
        {
             //msg.voice = voices[7];
        }
        else if(navUserAgent.indexOf("Safari") > -1)
        {
             //msg.voice = voices[7];
        }
        else if(navUserAgent.indexOf("OP") > -1)
        {
             //msg.voice = voices[7];
        }  
        else if(navUserAgent.indexOf("Edg") > -1)
        {
             //msg.voice = voices[25];
        } 
        //msg.voice = voices[5]; // Note: some voices don't support altering params
        let speechHtml = this.question + '. \n';   
        for (var i = 0; i < this.options.length; ++i) {
            speechHtml += this.options[i].optiontext+'. \n';
        }          
        msg.volume = 1; // 0 to 1
        msg.rate = 1; // 0.1 to 10
        msg.pitch = 0; //0 to 2
        msg.text = speechHtml;
        msg.lang = this.speechLang;  //hi-IN hindi india.
        speechSynthesis.speak(msg);              
        msg.onend = function(e) {
          speechSynthesis.cancel();
          clearTimeout(myTimeout);
        };


    }

    public textToSpeechOption(){
        var navUserAgent = navigator.userAgent;
        var msg = new SpeechSynthesisUtterance();
        var voices = window.speechSynthesis.getVoices();
        speechSynthesis.cancel();
        if(navUserAgent.indexOf("Opera") > -1) 
        {
             //msg.voice = voices[7];
        }else if(navUserAgent.indexOf("Chrome") > -1)
        {
           msg.voice = voices[7];
        }else if(navUserAgent.indexOf("MSIE") > -1 || navUserAgent.indexOf("rv:") > -1)
        {
             //msg.voice = voices[7];
        }else if(navUserAgent.indexOf("Firefox") > -1)
        {
             //msg.voice = voices[7];
        }
        else if(navUserAgent.indexOf("Safari") > -1)
        {
             //msg.voice = voices[7];
        }
        else if(navUserAgent.indexOf("OP") > -1)
        {
             //msg.voice = voices[7];
        }  
        else if(navUserAgent.indexOf("Edg") > -1)
        {
             //msg.voice = voices[25];
        } 
        //msg.voice = voices[5]; // Note: some voices don't support altering params
        let speechHtml;
        for (var i = 0; i < this.options.length; ++i) {
            //speechHtml += this.optionIndexText[i] + ' ? ';
            speechHtml += this.options[i].optiontext + '. \n';
        }     
        msg.volume = 1; // 0 to 1
        msg.rate = 1; // 0.1 to 10
        msg.pitch = 0; //0 to 2
        msg.text = speechHtml;
        msg.lang = this.speechLang;  //hi-IN hindi india.

        msg.onend = function(e) {
          speechSynthesis.cancel();
        };

        speechSynthesis.speak(msg);
    }



}
